exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".files-list[data-v-134e811a]{padding:10px;list-style:none}.btn-outline-danger[data-v-134e811a]{padding:1px 6px;border:none}", ""]);

// exports
